<!--
 * @Author       : qixiao
 * @Date         : 2023-05-13 15:14:07
 * @LastEditors  : qixiao
 * @LastEditTime : 2023-05-16 08:48:16
 * @FilePath     : \hzs-Houtai\src\views\Agricultural\AgriculturalMonitoring\index.vue
 * @Description  : 
 * 
-->

<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
    </div>
    <div class="main landMain">
      <Searchs @changeSearchName="changeSearchName" @changeMasterId="changeMasterId" />
      <LandMap :SearchName="SearchName" :MasterId="MasterId"></LandMap>
    </div>
  </el-main>
</template>

<script>
import bus from './component/LandMapNq/js/bus';
import LandMap from "./component/LandMapNq";
import Searchs from "./component/searchs";

export default {
  components: {LandMap,Searchs},
  props: [],
  data() {
    return {
      SearchName:'',
      MasterId:''
    };
  },
  mounted() {},
  created() {},
  methods: {
    changeSearchName(e){
      this.SearchName = e
    },
    changeMasterId(e){
      this.MasterId = e
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/common.scss";
.landMain {
  height: calc(100vh - 60px);
  padding: 10px 16px 30px 16px !important;
}
</style>
